/* eslint-disable react/prop-types */
import React from "react";
import { Typography, makeStyles } from "@material-ui/core";

const useStyles = makeStyles((theme) => ({
  container: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    padding: "5px",
    textAlign: "center",
    [theme.breakpoints.up("lg")]: {
      height: "100%",
    },
    overflow: "hidden",
  },
}));

function NoResultsComponent({ size = "medium", customText = "" }) {
  const classes = useStyles();
  let titleFontSize;
  let bodyVariant;

  switch (size) {
    case "small":
      titleFontSize = "22px";
      bodyVariant = "body2";
      break;
    default:
      titleFontSize = "30px";
      bodyVariant = "body1";
  }

  return (
    <div className={classes.container}>
      <Typography
        style={{
          fontWeight: "300",
          fontSize: titleFontSize,
          marginBottom: "10px",
        }}
      >
        No results found
      </Typography>
      <Typography
        variant={bodyVariant}
        style={{
          fontWeight: "300",
        }}
      >
        {customText !== ""
          ? customText
          : `Try adjusting your search or filters to find what you're looking
        for.`}
      </Typography>
    </div>
  );
}

export default NoResultsComponent;
